import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchPage = createAsyncThunk(
  "pageView/fetchPage",
  (pageId: number, { getState }) => {
    const { pages }: any = getState();
    const { data } = pages.pages.find((p: any) => p?.value === pageId);
    return data;
  },
);
